import { Period } from '../context/PeriodProvider';
import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { Role } from '../types/Role';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const CarClient = (config: ClientConfig) => {
    const { accessToken, userRole, param = '' } = config;
    const headers = getHeaders(accessToken);
    const baseClientConfig = {
        useAdminRoute: userRole === Role.ADMIN && param !== '',
    };

    const getCar = (period: Period): Promise<{ key: string; value: string; url?: string }[]> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.CAR)}/${param}?quarter=${period.quarter}&year=${period.year}`;

        return fetchAndParse<{ key: string; value: string; url: string }[]>(apiUrl, {
            headers,
        });
    };

    return {
        getCar,
    };
};
